// import React from 'react'
// import './RelatedProducts.css'
// import data_product from '../Assets/Frontend_Assets/data'
// import Item from '../Item/Item'

// const RelatedProducts = () => {
//     return (
//         <div className="relatedproducts">
//             <h1>Related Products</h1>
//             <hr />

//             <div className="relatedproducts-items">
//                 {data_product.map((item) => (
//                     <Item
//                         key={item.id}
//                         id={item.id}
//                         name={item.name}
//                         image={item.image}
//                         new_price={item.new_price}
//                         old_price={item.old_price}
//                     />
//                 ))}
//             </div>
//         </div>
//     )
// }

// export default RelatedProducts


import React, { useContext } from 'react'
import './RelatedProducts.css'
import { ShopContext } from '../../Context/ShopContext'
import Item from '../Item/Item'

const RelatedProducts = ({ currentProductId }) => {
    const { all_product } = useContext(ShopContext)

    return (
        <div className="relatedproducts">
            <h1>Related Products</h1>
            <hr />

            <div className="relatedproducts-items">
                {all_product
                    .filter(item => item.id !== currentProductId)
                    .slice(0, 4)
                    .map(item => (
                        <Item
                            key={item.id}
                            id={item.id}
                            name={item.name}
                            image={item.image}
                            new_price={item.new_price}
                            old_price={item.old_price}
                        />
                    ))}
            </div>
        </div>
    )
}

export default RelatedProducts
